import { render, staticRenderFns } from "./ShowMoneyToggleButton.vue?vue&type=template&id=b13e75c4&scoped=true"
import script from "./ShowMoneyToggleButton.vue?vue&type=script&lang=ts"
export * from "./ShowMoneyToggleButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13e75c4",
  null
  
)

export default component.exports